import './countryside/style';
import FormStructure from './countryside/form_structure';

export default FormStructure;